import { Component, OnInit, Input } from '@angular/core';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { EventsService } from '../../services/events-service/events.service';
import { DatewiseEvents } from '../../models/datewise-events';
import { CalendarDataCarrierService } from '../../services/calendar-datacarrier-service/calendar-data-carrier.service';
import { WidgetType } from '../../models/calendar-view-cache';
import { ScheduleOptionsCacheService } from '../../services/schedule-options-cache-service/schedule-options-cache.service';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent extends ComponentBase implements OnInit {

  constructor(private eventsService: EventsService
    , private calendarDataCarrierSvc: CalendarDataCarrierService
    , private scheduleOptionsCacheService: ScheduleOptionsCacheService) {
    super();
  }
  @Input() showExams: boolean = true;
  @Input() showHolidays: boolean = true;;
  @Input() showEvents: boolean = true;
  schedule: Array<DatewiseEvents>;
  todaysdate: string = new Date().toISOString().split('T')[0];

  ngOnInit() {
    let subscription = this.eventsService.getEventsForAccademicYear()
      .subscribe(res => {
        this.schedule = res;
      });
    this.addSubscription(subscription);

    this.calendarDataCarrierSvc.changeView(WidgetType.schedule);

    let sub2 = this.scheduleOptionsCacheService.subscribeScheduleOptions()
      .subscribe(res => {
        this.showHolidays = res.showHolidays;
        this.showEvents = res.showEvents;
        this.showExams = res.showExams;
      });
    this.addSubscription(sub2);
  }

  showDay(day: DatewiseEvents) {
    let t = 0;
    if (this.showExams) {
      t += day.exams.length;
    }
    if (this.showHolidays) {
      t += day.holidays.length;
    }
    if (this.showEvents) {
      t += day.general_events.length;
    }
    return t;
  }

}
